import { render, staticRenderFns } from "./PaletteIndex.vue?vue&type=template&id=0bbf88b5"
import script from "./PaletteIndex.vue?vue&type=script&lang=js"
export * from "./PaletteIndex.vue?vue&type=script&lang=js"
import style0 from "./PaletteIndex.vue?vue&type=style&index=0&id=0bbf88b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports